if (!customElements.get("product-form")) {
  class GiftWrap {
    constructor(container) {
      this.container = container;
      this.ribbonValue = "Bag With Matching Ribbon";
      this.productJson = JSON.parse(
        this.container.querySelector("script").innerHTML
      );

      this.initEvent();
      this.onlyCustomStyleOption();
    }

    initEvent = () => {
      const inputs_checkbox = this.container.querySelectorAll(
        'input[type="checkbox"]'
      );
      const inputs_radio = this.container.querySelectorAll(
        'input[type="radio"]'
      );
      const w_product_color = this.container.querySelector(
        ".w-product--option_color"
      );
      const error = this.container.querySelector(".text.error");
      setTimeout(function(){
        var parent = document.querySelector(".product-form__input .qty-n-price");
        if (parent) {
            var cv_price = document.querySelector("variant-radios").currentVariant.price;
            var cv_qty = document.querySelector("quantity-input").querySelector('.quantity__input').value;
            var price = parent.querySelector(".price .price-item");
            var wrappingValueFields = document.querySelector('.auto-wrapping_options_hidden-fields');
            var html = '';
            var selectedWrapping = [];
            var c_gift_wraping = document.querySelectorAll('.additional-section ul.list-option--type li input[type="checkbox"]:checked');
            const giftWrapHiddenInput = document.querySelector('.gift-property_hidden-input');
            var eachItemHiddenPrice = document.querySelector(".product-form__quantity .qty-n-price .each-value .each-price_hidden").innerText;
            var eachItemPrice = document.querySelector(".product-form__quantity .qty-n-price .each-value .each-price") || document.querySelector(".product-form__quantity .qty-n-price .each-value .omg-per-item-price");
            const with_ribbon_gift_box = document.querySelector(
              ".additional-section.w-product .w-product--option_type .list-option--type input[value='Bag With Ribbon']"
            );
            const with_match_ribbon_gift_box = document.querySelector(
              ".additional-section.w-product .w-product--option_type .list-option--type input[value='Bag With Matching Ribbon']"
            );
            var selectedWrapping = [];
            _theme.sumOfPrice = 0;
            c_gift_wraping.forEach((c_gift_wrap, i) => {
              selectedWrapping.push(c_gift_wrap.value);
              if(c_gift_wrap.parentElement.classList.contains('hidden')) return false;
              var currentDataId = c_gift_wrap.getAttribute('data-vid');
              var hiddenInput = document.querySelector('.form-buy-buttons .wrapping_options');
              var qty_n_price = cv_qty * cv_price;
              const formatted_price = Shopify.formatMoney(qty_n_price);
              var checkedInputPrice = c_gift_wrap.parentElement.querySelector('.w-product--info .money').innerText;
              var regex = /[+-]?\d+(\.\d+)?/g;
              var floatConvPrice = parseFloat(checkedInputPrice.match(regex));
              if (isNaN(floatConvPrice)) floatConvPrice = 0;
              _theme.sumOfPrice = _theme.sumOfPrice + parseFloat(floatConvPrice);

              // EACH ITEM PRICE INCREASE ON WRAPPING RIBBON SELECTION
              if(c_gift_wrap.value.toLowerCase() == "bag with matching ribbon" || c_gift_wrap.value.toLowerCase() == "bag with ribbon"){
                const priceWithRibb = parseFloat(eachItemHiddenPrice.match(regex)) + floatConvPrice;
                eachItemPrice.innerHTML = Utils.formatMoney(priceWithRibb);
              } 
              if(!with_ribbon_gift_box.checked && !with_match_ribbon_gift_box.checked) {
                eachItemPrice.innerHTML = eachItemHiddenPrice;
              }
              if(!c_gift_wrap.value.toLowerCase().includes('giftbox')){
                _theme.sumOfPrice = _theme.sumOfPrice * cv_qty;
              }
              else {
                _theme.sumOfPrice = _theme.sumOfPrice;
              }
              var newPrice = parseFloat(formatted_price.replace(/[^a-zA-Z0-9 .]/g, '')) + _theme.sumOfPrice;
              if(isNaN(parseFloat(newPrice))){
                price.innerHTML = Utils.formatMoney(qty_n_price);
              } else {
                price.innerHTML = Utils.formatMoney(parseFloat(newPrice));
              }
              if(c_gift_wrap.value == 'Giftbox with Matching Ribbon'){
                html += `<input type="hidden" name="items[${i}][quantity]" class="wrapping_options_qty" value="1">
                  <input type="hidden" name="items[${i}][id]" class="wrapping_options" value="${currentDataId}">`;
              } else {
              html += `<input type="hidden" name="items[${i}][quantity]" class="wrapping_options_qty" value="${cv_qty}">
                  <input type="hidden" name="items[${i}][id]" class="wrapping_options" value="${currentDataId}">`;
              }
            })
            html += `<input type="hidden" name="properties[Gift_Wrap]" class="gift-property_hidden-input" value="${selectedWrapping.toString().split(',').join(', ')}">`;
            wrappingValueFields.innerHTML = html;
        }
        //CHANGE IMAGE TO DEFAULT ONE WHEN STYLE TEXT IS EMPTY
        let personalizeTextAreas = document.querySelectorAll('.product-personalizer .pplr-text');
        personalizeTextAreas.forEach(inputBox => {
          if(!inputBox.classList.contains('pplr_no_preview')) {
            var inputTextArea = inputBox.querySelector('.pplr_text');
            inputTextArea && inputTextArea.addEventListener('input', () => {
              if(!inputTextArea.value){
                setTimeout(function() {
                  var curSlide = document.querySelector('.product-feature-slider .slick-current.slick-active .featured-product-image');
                  curSlide.classList.remove('pplr');
                  curSlide.querySelector('span.pplr_preview_wrapper').remove();
                }, 1000);
              }
            });
          }
        });

        document.querySelectorAll('.additional-section-body label.disabled').forEach(enableClick => {
          enableClick.classList.remove('disabled');
        })
      }, 2000);
      inputs_checkbox.forEach((input) => {
        input.addEventListener("change", (evt) => {
            var parent = document.querySelector(".product-form__input .qty-n-price");
            var cv_price = document.querySelector("variant-radios").currentVariant.price;
            var cv_qty = document.querySelector("quantity-input").querySelector('.quantity__input').value;
            let selectedTier = window.minMaxArray.tiers?.find(tier => cv_qty >= tier.min && cv_qty <= tier.max); // new line 26/12
            cv_price = selectedTier != undefined && selectedTier ? (selectedTier.price*100) : cv_price; // new line 26/12
            var price = parent.querySelector(".price .price-item");
            const eachPriceElement = document.querySelector('.each-price') || document.querySelector('.omg-per-item-price'); // new line 26/12
            var wrappingValueFields = document.querySelector('.auto-wrapping_options_hidden-fields');
            var html = '';
            var selectedWrapping = [];
            var active_inputs = this.container.querySelectorAll(
              'input[type="checkbox"]:checked'
            );
            var cellophane_gift_box = document.querySelector(
              ".additional-section.w-product .w-product--option_type .list-option--type input[value='Sealed Cellophane Bag']"
            );
            var clickedOnCellophane = false;
            switch (input.value) {
              case "Sealed Cellophane Bag":
                inputs_checkbox.forEach((input_cb) => {
                  if (input_cb.value === "Bag With Matching Ribbon" || input_cb.value === "Bag With Ribbon" && input_cb.checked ) { 
                    input_cb.checked = false;
                  }
                });
                clickedOnCellophane = true;
                break;
  
              case "Bag With Matching Ribbon":
                if(cellophane_gift_box && cellophane_gift_box.checked) {
                  cellophane_gift_box.checked = false;
                }
                break;
              case "Bag With Ribbon":
                if(cellophane_gift_box && cellophane_gift_box.checked) {
                  cellophane_gift_box.checked = false;
                }
                break;
              case "Giftbox with Matching Ribbon":
            }
            let is_ribbon_active = false;
            active_inputs.forEach((active_input) => {
              if (active_input.value === this.ribbonValue || active_input.value === 'Bag With Ribbon') {
                if(!clickedOnCellophane) is_ribbon_active = true;
              }
            });
            var hasColorVariant = document.querySelector('fieldset.options--cookie-style .custom-style');
            const customStyleShow = hasColorVariant && hasColorVariant.classList.contains('hidden');
            const with_ribbon_gift_box = document.querySelector(
              ".additional-section.w-product .w-product--option_type .list-option--type input[value='Bag With Ribbon']"
            );
            const with_match_ribbon_gift_box = document.querySelector(
              ".additional-section.w-product .w-product--option_type .list-option--type input[value='Bag With Matching Ribbon']"
            );
            if(active_inputs.length === 1 && active_inputs[0].value === "Giftbox with Matching Ribbon") {
              inputs_checkbox[0].checked = true;
            }
            if (is_ribbon_active && !customStyleShow) {
              hasColorVariant && w_product_color.classList.remove("hidden");
              hasColorVariant && with_ribbon_gift_box.parentNode.classList.contains('hidden') && with_ribbon_gift_box.parentNode.classList.remove('hidden');
              hasColorVariant && !with_match_ribbon_gift_box.parentNode.classList.contains('hidden') && with_match_ribbon_gift_box.parentNode.classList.add('hidden');
              if(!with_ribbon_gift_box.parentNode.classList.contains('hidden')){
                with_match_ribbon_gift_box.checked = false;
                with_ribbon_gift_box.checked = true;
              }
            }
            else {
              w_product_color.classList.add("hidden");
              with_ribbon_gift_box && !with_ribbon_gift_box.parentNode.classList.contains('hidden') && with_ribbon_gift_box.parentNode.classList.add('hidden');
              with_match_ribbon_gift_box && with_match_ribbon_gift_box.parentNode.classList.contains('hidden') && with_match_ribbon_gift_box.parentNode.classList.remove('hidden');
            }
  
            if (active_inputs.length === 0 && inputs_checkbox[0].value != "Giftbox with Matching Ribbon") inputs_checkbox[0].checked = true; //input.checked = true;
          
            var c_gift_wraping = document.querySelectorAll('.additional-section ul.list-option--type li input[type="checkbox"]:checked');
            const giftWrapHiddenInput = document.querySelector('.gift-property_hidden-input');
            var eachItemHiddenPrice = document.querySelector(".product-form__quantity .qty-n-price .each-value .each-price_hidden").innerText;
            var eachItemPrice = document.querySelector(".product-form__quantity .qty-n-price .each-value .each-price") || document.querySelector(".product-form__quantity .qty-n-price .each-value .omg-per-item-price");
            var selectedWrapping = [];
            _theme.sumOfPrice = 0;
            _theme.singleWrapPrice = 0; // new line 26/12
            if(c_gift_wraping != ''){
              const qty_n_price = cv_qty * cv_price;
              price.innerText = Shopify.formatMoney(qty_n_price);
              wrappingValueFields.innerHTML = '';
            }
            c_gift_wraping.forEach((c_gift_wrap, i) => {
              selectedWrapping.push(c_gift_wrap.value);
              if(c_gift_wrap.parentElement.classList.contains('hidden')) return false;
              var currentDataId = c_gift_wrap.getAttribute('data-vid');
              var hiddenInput = document.querySelector('.form-buy-buttons .wrapping_options');
              var qty_n_price = cv_qty * cv_price;
              const formatted_price = Shopify.formatMoney(qty_n_price);
              var checkedInputPrice = c_gift_wrap.parentElement.querySelector('.w-product--info .money').innerText;
              var regex = /[+-]?\d+(\.\d+)?/g;
              var floatConvPrice = parseFloat(checkedInputPrice.match(regex));
              if (isNaN(floatConvPrice)) floatConvPrice = 0;
              _theme.sumOfPrice = _theme.sumOfPrice + parseFloat(floatConvPrice);
              _theme.singleWrapPrice += !c_gift_wrap.value.toLowerCase().includes('giftbox') ? parseFloat(floatConvPrice) : 0; // new line 26/12
              // EACH ITEM PRICE INCREASE ON WRAPPING RIBBON SELECTION
              if(c_gift_wrap.value.toLowerCase() == "bag with matching ribbon" || c_gift_wrap.value.toLowerCase() == "bag with ribbon"){
                const priceWithRibb = parseFloat(eachItemHiddenPrice.match(regex)) + floatConvPrice;
                eachItemPrice.innerHTML = Utils.formatMoney(priceWithRibb);
              } 
              if(!with_ribbon_gift_box.checked && !with_match_ribbon_gift_box.checked) {
                eachItemPrice.innerHTML = eachItemHiddenPrice;
              }
              
              if(!c_gift_wrap.value.toLowerCase().includes('giftbox')){
                _theme.sumOfPrice = _theme.sumOfPrice * cv_qty;
              }
              else {
                _theme.sumOfPrice = _theme.sumOfPrice;
              }
              var newPrice = parseFloat(formatted_price.replace(/[^a-zA-Z0-9 .]/g, '')) + _theme.sumOfPrice;
              if(isNaN(parseFloat(newPrice))){
                price.innerHTML = Utils.formatMoney(qty_n_price);
              } else {
                price.innerHTML = Utils.formatMoney(parseFloat(newPrice));
              }
              if(c_gift_wrap.value == 'Giftbox with Matching Ribbon'){
                html += `<input type="hidden" name="items[${i}][quantity]" class="wrapping_options_qty" value="1">
                  <input type="hidden" name="items[${i}][id]" class="wrapping_options" value="${currentDataId}">`;
              } else {
              html += `<input type="hidden" name="items[${i}][quantity]" class="wrapping_options_qty" value="${cv_qty}">
                  <input type="hidden" name="items[${i}][id]" class="wrapping_options" value="${currentDataId}">`;
              }
            })
            eachPriceElement.textContent = Shopify.formatMoney(((cv_price/100) + _theme.singleWrapPrice)*100); // new line 26/12
            html += `<input type="hidden" name="properties[Gift_Wrap]" class="gift-property_hidden-input" value="${selectedWrapping.toString().split(',').join(', ')}">`;
            wrappingValueFields.innerHTML = html;
        });
      });

      inputs_radio.forEach((input) => {
        input.addEventListener("change", (evt) => {
          error.classList.add("hidden");
        });
      });
    };

    getCurrentVariant = (showError) => {
      const typeActiveInput = this.container.querySelectorAll(
        '.w-product--option_type input[type="checkbox"]:checked'
      );
      const colorActiveInput = this.container.querySelector(
        '.w-product--option_color input[type="radio"]:checked'
      );

      const result = { status: true, variants: [] };
      result.variants = this.productJson.variants.filter((v) => {
        let match = false;
        typeActiveInput.forEach((input) => {
          if (v.id != input.dataset.vid) return;
          match = true;
          if (input.value === this.ribbonValue) { 
            if (colorActiveInput) {
              result.status = true;
              result["ribbon_color"] = colorActiveInput.value;
            } else {
              result.status = false;
              showError &&
                this.container
                  .querySelector(".text.error")
                  .classList.remove("hidden");
            }
          }
        });
        return match;
      });
      return result;
    };

    onlyCustomStyleOption = () => {
      var hasStyleOptions = document.querySelectorAll('.options--cookie-style ul.option-items.color_shades li');
      if(hasStyleOptions.length == 1 && hasStyleOptions[0].dataset.value == "Custom") {
        hasStyleOptions[0].parentElement.classList.remove('hidden');
        document.querySelector('.options--cookie-style .custom-style').classList.add('hidden');
        setTimeout(function(){
          hasStyleOptions[0].addEventListener("click", (event) => {
            if(!hasStyleOptions[0].parentElement.classList.contains('hidden')) {
              hasStyleOptions[0].parentElement.classList.add('hidden');
              document.querySelector('.options--cookie-style .custom-style').classList.remove('hidden');
              const first_input = parent.querySelector('input[type="radio"]');
              first_input.checked = true;
              first_input.dispatchEvent(new window.Event('change', { bubbles: true }));
            }
          });
          const parent = document.querySelector('fieldset.options--cookie-style');
          const backToCTA = parent.querySelector('fieldset.options--cookie-style .custom-style .back-to');
          const custom_color_inputs = document.querySelector('.product--block .custom-style .custom-style-list');
          backToCTA && backToCTA.addEventListener('click', evt => {
              hasStyleOptions[0].parentElement.classList.remove('hidden');
              document.querySelector('.options--cookie-style .custom-style').classList.add('hidden');
              const checked_gift_boxes = document.querySelectorAll(
                ".additional-section.w-product .w-product--option_type .list-option--type input[type='checkbox']:checked"
              );
              const gift_wrap_main = document.querySelector(
                ".w-product .w-product--option.w-product--option_color"
              );
              const gift_wrap_custom = document.querySelector(
                ".w-product .custom-colors"
              );
              setTimeout(function(){
                checked_gift_boxes.forEach(checked_gift_box => {
                  if(checked_gift_box.value == "Bag With Ribbon"){
                    checked_gift_box.parentNode.previousSibling.previousElementSibling.classList.remove("hidden");
                    checked_gift_box.parentNode.classList.add('hidden');
                    checked_gift_box.checked = false;
                    checked_gift_box.parentNode.previousSibling.previousElementSibling.children[1].children[0].children[0].click();
                  }
                  if(!gift_wrap_custom.classList.contains('hidden') && checked_gift_box.value == "Bag With Matching Ribbon"){
                    checked_gift_box.parentNode.nextSibling.nextElementSibling.classList.remove("hidden");
                    checked_gift_box.parentNode.classList.add('hidden');
                    checked_gift_box.parentNode.nextSibling.nextElementSibling.children[1].children[0].children[0].click();
                  }
                  if(!gift_wrap_custom.classList.contains('hidden') && checked_gift_box.value != "Bag With Matching Ribbon" && checked_gift_box.value != "Bag With Ribbon") {
                    var matchingRibbon = document.querySelector(
                        ".additional-section.w-product .w-product--option_type .list-option--type input[value='Bag With Matching Ribbon']"
                      );
                    const withRibbon = document.querySelector(
                        ".additional-section.w-product .w-product--option_type .list-option--type input[value='Bag With Ribbon']"
                      );
                    matchingRibbon.parentNode.classList.remove('hidden');
                    withRibbon.parentNode.classList.add('hidden');
                  }
                })
              }, 300);
          });
          const gift_boxes = document.querySelectorAll(
                ".additional-section.w-product .w-product--option_type .list-option--type input[type='checkbox']"
              );
          gift_boxes[0].checked = true;
          gift_boxes[0].dispatchEvent(new window.Event('change', { bubbles: true }));
          gift_boxes[0].click();
        }, 3000);
      }
    }
  }

  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.style_pos = _theme.product.style_pos || "option2";
        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.submitCTA = this.form.querySelector('[type="submit"]');
        this.submitCTA.addEventListener(
          "click",
          this.onSubmitHandler.bind(this)
        );
        this.cartNotification = document.querySelector("cart-notification");

        const giftwrap = document.querySelector(
          ".additional-section.w-product"
        );
        if (giftwrap) this.giftwrap = new GiftWrap(giftwrap);
      }

      addPersonalizeMsg = (item) => {
        const personalizeMsg = document.querySelector(
          ".personalize-message textarea"
        );
        if (personalizeMsg && personalizeMsg.value.trim()) {
          item.properties = item.properties || {};
          item.properties["Personalize Message"] = personalizeMsg.value;
        }

        return item;
      };

      getDeliveryDate = () => {
        const datePicker = document.querySelector(
          ".identixweb-product-order-delivery"
        );
        let date_formatted = null;
        if (!datePicker) return date_formatted;
        const delDatePicker = datePicker.querySelector(".uiDeliveryCalendar");
        const del_date = datePicker.querySelector(".uiDeliveryDateVal").value;
        const del_day = datePicker.querySelector(".uiDeliveryDateVal").value;
        const errorNode = datePicker.querySelector(".deliveryRequired");
        if (del_date && del_day) {
          var dd = new Date(del_date);
          date_formatted = dd.toDateString();
          errorNode.textContent = "";
          delDatePicker.classList.remove("uiRequired");
        } else {
          delDatePicker.classList.add("uiRequired");
          errorNode.textContent =
            oddEditdateProductRequiredText || "Please select delivery date";
        }
        return date_formatted;
      };

      getCurrentVariant = () => {
        return document.querySelector("variant-radios").currentVariant;
      };

      validateCustomStyle = () => {
        const current_variant = this.getCurrentVariant();
        if (!current_variant) return null;
        let result = { status: true, current_variant: current_variant };
        let style = current_variant[this.style_pos];
        if (!style) return result;
        const style_active_input = document.querySelector(
          'fieldset.options--cookie-style .option-items input[type="radio"]:checked'
        );
        let style_active_input_val = '';
        if(style_active_input){
          let style_active_input_val = style_active_input.value.toLowerCase(); 
        }
        if (
          style.toLowerCase() === "custom" &&
          style_active_input_val === "custom"
        ) {
          const li_dataset =
            style_active_input.closest("li[data-value]").dataset;
          result.colors = {};
          for (let key in li_dataset) {
            if (key === "value") continue;
            result.colors[key] = li_dataset[key];
          }
          const custom_color_error = document.querySelector(
            ".custom-style .error"
          );
          if (Object.keys(result.colors).length) {
            result.status = true;
            custom_color_error.classList.add("hidden");
          } else {
            custom_color_error.classList.remove("hidden");
            result.status = false;
            delete result.colors;
          }
        } else {
          result["style"] = style;
        }
        return result;
      };

      deleteVariantFromCart = (cart, successCB, errorCB) => {
        const key = _theme.Helpers.getParamFromURL("key");
        if (key) {
          const master_item = cart.items.filter(
            (line_item) => line_item.key === key
          )[0];
          let child_items = null;
          const bundle_id =
            master_item &&
            master_item.properties &&
            master_item.properties["Bundle_ID"];

          if (bundle_id) {
            child_items = cart.items.filter((line_item) => {
              if (line_item.properties) {
                var bid = line_item.properties["Bundle_ID"];
                var type = line_item.properties["_type"];
                return bid && bid === bundle_id && type && type === "Child";
              }
              return false;
            });

            var parameters = [];
            cart.items.map((item) => {
              var param = { name: "updates[]" };
              var value = item.quantity;
              if (item.key === master_item.key) value = 0;
              if (child_items.length) {
                child_items.map((ci) => {
                  if (item.key === ci.key) value = 0;
                });
              }
              param.value = value;
              parameters.push(param);
            });

            var delDateAttributes = [];
            cart.items.map((item) => {
              var delDate = item.properties && item.properties.DeliveryDate;
              if (delDate && item.key !== key) {
                const d = new Date(delDate);
                const deldate = window.oddt_get_date_formated(d, "mm/dd/yy");
                const delday = window.oddt_day_text_value(delDate);
                delDateAttributes.push({
                  DeliveryDate: deldate,
                  DeliveryDay: delday,
                  DeliveryTime: "",
                  product_id: item.product_id,
                  variant_id: item.variant_id,
                });
              }
            });

            if (delDateAttributes.length) {
              parameters.push({
                name: "attributes[OrderDeliveryDate]",
                value: JSON.stringify(delDateAttributes),
              });
            }

            const form = _theme.Helpers.buildForm("/cart", {
              method: "post",
              parameters: parameters,
            });

            var serialize = $(form).serialize();
            _theme.Helpers.updateCart(
              serialize,
              (cart) => {
                // console.log('hello success', cart);
                if (successCB && typeof successCB === "function") {
                  successCB(cart);
                }
              },
              (err) => {
                console.log("error", err);
                if (errorCB && typeof errorCB === "function") {
                  errorCB(err);
                }
              }
            );
          }
        }
      };

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitCTA.classList.contains("loading")) return;

        // Key in Query String , Edit Product
        const vkey = _theme.Helpers.getParamFromURL("key");
        
        // NEW CUSTOM ADDED CODE TO UPDATE CART ITEM
        if(vkey){
          let newBody = JSON.parse(serializeForm(this.form));
          var wrap = this.giftwrap.getCurrentVariant(1);
          var updates = {};
          _theme.Helpers.fetchCart()
          .then(function(result) {
            // NEW UPDATE QTY
            const visibleItems = result.items.filter(visibleItem => visibleItem.properties["Gift_Wrap"]);
            const hiddenItems = result.items.filter(hiddenItem => !hiddenItem.properties["Gift_Wrap"]);
            if(visibleItems && hiddenItems) {
              hiddenItems.forEach(hiddenItem => {
                var itemqty = 0;
                var giftQty = 0;
                visibleItems.forEach(visibleItem => {
                  var lineProperty = visibleItem.properties['Gift_Wrap'];
                  if(lineProperty.includes(hiddenItem.variant_title) && hiddenItem.variant_title != "Giftbox with Matching Ribbon"){
                    itemqty += visibleItem.quantity;
                  }
                  if(lineProperty.includes(hiddenItem.variant_title) && visibleItem.variant_id == newBody.id) {
                    itemqty -= visibleItem.quantity;
                  }
                  if(visibleItem.variant_id == newBody.id){
                    wrap.variants.find(({id, title}) => {
                      if(hiddenItem.variant_title == title && title != "Giftbox with Matching Ribbon") {
                        itemqty = itemqty + parseInt(newBody.quantity);
                      }
                    })
                  }
                  if(lineProperty.includes(hiddenItem.variant_title) && hiddenItem.variant_title == "Giftbox with Matching Ribbon"){
                      giftQty++;
                  }
                })
                if(hiddenItem.variant_title == "Giftbox with Matching Ribbon"){
                  updates[hiddenItem.variant_id] = parseInt(giftQty);
                } else {
                  updates[hiddenItem.variant_id] = parseInt(itemqty);
                }
              })
            }
          })
          .catch(function(err) {
              // handle your errors here
          });
          console.log(updates);
          updates[newBody.id] = newBody.quantity;
          setTimeout(function(){
            const config = fetchConfig("javascript");
            config.headers["X-Requested-With"] = "XMLHttpRequest";
            config.body = JSON.stringify({ updates });
            fetch(window.routes.cart_update_url, config)
            .then((res) => res.json())
            .then((cart) => {
              window.SLIDECART_UPDATE(cart);
              setTimeout(function(){
                const allCartItems = document.querySelectorAll('.slidecarthq .items .item');
                document.querySelector('.header .cart-count').classList.remove('hidden');
                allCartItems.forEach(item => {
                  var itemTitle = item.querySelector('.main-top .title a').innerText.replace(/\s+/g, '-').toLowerCase();
                  if(itemTitle != 'gift-wrap'){
                    item.classList.remove('hidden');
                  }
                })
              }, 700);
              setTimeout(function(){
                var itemQty = 0;
                cart.items.find(({product_title, quantity }) => {
                  const proTitle = product_title.toLowerCase();
                  if(proTitle != 'gift wrap'){
                    itemQty += quantity;
                  }
                })
                var cartIcon = document.querySelector('#cart-icon-bubble.header__icon--cart');
                if(itemQty === 0){
                  if(cartIcon.querySelector('.cart-count-bubble')) {
                    cartIcon.querySelector('.cart-count-bubble').remove();
                  }
                } else {
                  const cartCountHtml = `<div class="cart-count-bubble" bis_skin_checked="1"><span aria-hidden="true" class="pplr_cart_count">${itemQty}</span></div>`;
                  cartIcon.querySelector('.cart-count-bubble') ? cartIcon.querySelector('.cart-count-bubble').innerText = itemQty : cartIcon.innerHTML += cartCountHtml;
                  document.querySelector('header h2 .cart-count').innerText = itemQty;
                }
                cart.items.forEach((item) => {
                  if (item.properties !== null) {
                    //check if the items have the preview property
                    if (item.properties["Preview"]) {
                      item.image = item.properties["Preview"];
                    }
                    //ADD WRAP ITEM PRICE TO PARENT PRODUCT PRICE
                    if (item.properties["Gift_Wrap"]) {
                      const filteredItems = cart.items.filter(wrapPro => wrapPro.product_title == "Gift Wrap");
                      if(!filteredItems) return;
                      var wrapPrice = 0;
                      var qty = 0;
                      filteredItems.forEach((wrapItem) => {
                        if(item.properties['Gift_Wrap'].includes(wrapItem.variant_title)){
                          if(wrapItem.variant_title == 'Giftbox with Matching Ribbon'){
                              qty = 1;
                          }else {
                            qty = item.quantity;
                          }
                          const wrapDecimalPrice = wrapItem.price/100;
                          wrapPrice += wrapDecimalPrice * qty;
                        }
                      })
                      const parentItemPrice = item.price/100 * item.quantity;
                      const CartParentItem = document.querySelector('.slidecarthq .items .item[data-variant-id="'+item.id+'"]');
                      CartParentItem.querySelector('.main-bottom .price').innerText = Shopify.formatMoney((parentItemPrice + wrapPrice) * 100);
                    }
                  }
                });
              }, 500);
            })
          }, 1000);
        }
        //END CODE TO UPDATE CART ITEM
        
        // Cookie Custom Style
        const style_res = this.validateCustomStyle();
        // Additional Product :: 'Wrapped'
        const giftwrap = this.giftwrap.getCurrentVariant(1);
        // ADD DELIVERY DATE
        const delDate = this.getDeliveryDate();

        if (!style_res.status || !giftwrap.status || !delDate) return;

        this.handleErrorMessage();
        this.cartNotification.setActiveElement(document.activeElement);

        // Show Loading
        _theme.Helpers.toggleButtonLoading(this.submitCTA, 1);

        // fetch unique Id
        const unique_bundle_id = _theme.Helpers.uniqueId("bid_");
        const formData = {
          items: [],
          sections: this.cartNotification
            .getSectionsToRender()
            .map((section) => section.id),
          sections_url: window.location.pathname,
        };

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        let body = JSON.parse(serializeForm(this.form));

        // MASTER PRODUCT
        formData.product_id = body.id;
        let master_product = {
          id: body.id,
          quantity: body.quantity,
          properties: {
            Bundle_ID: unique_bundle_id,
            _type: "Master",
            DeliveryDate: delDate,
          },
        };

        if (style_res.colors && this.shadeList) {
          for (let key in this.shadeList) {
            const key_upcase = key.toUpperCase();
            master_product.properties[`_${key_upcase}`] = this.shadeList[key];
          }
        } else {
          if (style_res.style) {
            master_product.properties["Style"] = style_res.style;
          }
        }

        // ADD PERSONALIZE MESSAGE
        master_product = this.addPersonalizeMsg(master_product);
        formData.items.push(master_product);

        // CHILD PRODUCT
        if (giftwrap.variants.length) {
          master_product.properties["Gift_Wrap"] = giftwrap.variants
            .map((v) => v.title)
            .join(", ");
          // GIFT WRAP RIBBON COLOR, IF SELECTED
          if (giftwrap.ribbon_color) {
            master_product.properties["Ribbon Color"] = giftwrap.ribbon_color;
          }

          giftwrap.variants.map((v) => {
            let qty = 1;
            if (v.title.toLowerCase().includes("ribbon") && !v.title.toLowerCase().includes("giftbox")) {
              qty = body.quantity;
            }
            const child_item = {
              id: v.id,
              quantity: qty,
              properties: {
                Bundle_ID: unique_bundle_id,
                _type: "Child",
                //"_Master_Title": style_res.current_variant.title
              },
            };

            formData.items.push(child_item);
          });
        }

        config.body = JSON.stringify(formData);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }

            if (vkey) {
              _theme.Helpers.fetchCart()
                .then((cart) => {
                  this.deleteVariantFromCart(
                    cart,
                    () => {
                      _theme.Helpers.toggleButtonLoading(this.submitCTA, 0);
                      _theme.Helpers.showToastModal(
                        1,
                        "Variant updated successfully"
                      );
                      _theme.Helpers.goTo("/cart", 2000);
                    },
                    () => {
                      _theme.Helpers.toggleButtonLoading(this.submitCTA, 0);
                      _theme.Helpers.showToastModal(
                        1,
                        "Something went wrong. try again"
                      );
                    }
                  );
                })
                .catch((err) => console.log(err));
            } else {
              this.cartNotification.renderContents(response);
            }
          })
          .catch((error) => {
            console.error("Error:", error);
          })
          .finally(() => {
            if (!vkey) _theme.Helpers.toggleButtonLoading(this.submitCTA, 0);
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          document.querySelector(".product-form__error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
